import React, { useCallback, useState } from "react";
import "./ChatPage.css";
import ChatList from "./ChatList";
import ChatWindow from "./ChatWindow";
import BackLink from "../BackLink";
import { useLocation, useNavigate } from "react-router-dom";

const ChatPage = ({ token, currentProfileId }) => {
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [readConversationIds, setReadConversationIds] = useState([]);

  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const initialAutoOpenId = params.get("conversation")
    ? Number(params.get("conversation"))
    : null;

  const [autoOpenId, setAutoOpenId] = useState(initialAutoOpenId);
  const backFallback = params.get("backTo")
    ? decodeURIComponent(params.get("backTo"))
    : "/";

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const nextId = params.get("conversation")
      ? Number(params.get("conversation"))
      : null;

    setAutoOpenId(nextId);
  }, [location.search]);
  React.useEffect(() => {
  const handlePresenceUpdated = (event) => {
    const data = event.detail;

    if (!data?.profile_id) {
      return;
    }

    setSelectedConversation((prev) => {
      if (!prev) {
        return prev;
      }

      const profileId = String(data.profile_id);
      let changed = false;

      const updateProfile = (profile) => {
        if (!profile || String(profile.id) !== profileId) {
          return profile;
        }

        changed = true;

        return {
          ...profile,
          is_online: Boolean(data.is_online),
          last_seen: data.last_seen ?? profile.last_seen,
        };
      };

      const nextA = updateProfile(prev.a);
      const nextB = updateProfile(prev.b);

      if (!changed) {
        return prev;
      }

      return {
        ...prev,
        a: nextA,
        b: nextB,
      };
    });
  };

  window.addEventListener("profile-presence-updated", handlePresenceUpdated);

  return () => {
    window.removeEventListener("profile-presence-updated", handlePresenceUpdated);
  };
}, []);

  const handleSelectConversation = useCallback((conv) => {
    const updatedConv = {
      ...conv,
      has_unread: false,
    };

    // Чат выбран вручную или автоматически — старый autoOpenId больше не должен мешать.
    setAutoOpenId(null);

    setSelectedConversation(updatedConv);

    const nextParams = new URLSearchParams(location.search);
    const currentConversationId = nextParams.get("conversation");

    if (String(currentConversationId) !== String(conv.id)) {
      nextParams.set("conversation", String(conv.id));

      navigate(`/chat?${nextParams.toString()}`, {
        replace: true,
      });
    }

    setReadConversationIds((prev) => {
      if (prev.includes(conv.id)) return prev;
      return [...prev, conv.id];
    });

    window.dispatchEvent(new Event("refresh-unread-count"));
  }, [location.search, navigate]);

  const handleConversationRead = useCallback((conversationId) => {
    setReadConversationIds((prev) => {
      if (prev.includes(conversationId)) return prev;
      return [...prev, conversationId];
    });

    window.dispatchEvent(new Event("refresh-unread-count"));
  }, []);

  return (
    <div className="chatpage-container">
      {/* ШАПКА как на CategoryPicker: стрелка слева */}
      <div className="chatpage-header">
        <div className="chatpage-header-left">
          <BackLink label="Πίσω" fallbackTo={backFallback} />
        </div>
        <div className="chatpage-header-center"></div>
        <div className="chatpage-header-right"></div>
      </div>

      {/* Основная область: список + окно */}
      <div className="chatpage-body">
        {/* Список диалогов */}
        <div
          className={`chatpage-list ${
            selectedConversation ? "hidden-on-mobile" : ""
          }`}
        >
          <ChatList
            token={token}
            currentProfileId={currentProfileId}
            autoOpenId={autoOpenId}
            readConversationIds={readConversationIds}
            onSelectConversation={handleSelectConversation}
          />
        </div>

        {/* Окно сообщений */}
        <div
          className={`chatpage-window ${
            !selectedConversation ? "hidden-on-mobile" : ""
          }`}
        >
          {selectedConversation ? (
            <ChatWindow
              key={selectedConversation.id}
              token={token}
              conversation={selectedConversation}
              currentProfileId={currentProfileId}
              onBack={() => {
                setAutoOpenId(null);
                setSelectedConversation(null);

                if (backFallback && backFallback !== "/") {
                  navigate(`/chat?backTo=${encodeURIComponent(backFallback)}`, {
                    replace: true,
                  });
                } else {
                  navigate("/chat", { replace: true });
                }
              }}
              onConversationRead={handleConversationRead}
            />
          ) : (
            <div className="chatpage-placeholder">
              <p>Επίλεξε μια συνομιλία για να ξεκινήσεις 💬</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatPage;